import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private readonly apiHosts = [
    environment.apiBaseUrl,
    environment.mobileOrderBaseUrl,
  ];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isApiRequest = this.apiHosts.some(base => request.url.startsWith(base));

    if (isApiRequest) {
      request = request.clone({
        setHeaders: { 'Content-Type': 'application/json' },
      });
    }

    return next.handle(request);
  }
}
